<script>
import { createTemplate, updateTemplate } from '@/utils/whatsapp-followup-template'

export default {

    inject: ['setLoading'],

    data() {
        return {

            id: null,
            name: '',
            code: '',
            template_id: '',
            trigger_after: '',
            errors: {}

        }
    },

    methods: {

        template(row = null) {

            this.reset()

            if (!row) return

            this.id = row.id
            this.name = row.name
            this.code = row.code
            this.template_id = row.template_id
            this.trigger_after = row.trigger_after

        },

        async save() {

            this.errors = {}

            this.setLoading(true)

            try {

                const payload = {
                    name: this.name,
                    code: this.code,
                    template_id: this.template_id,
                    trigger_after: this.trigger_after
                }

                let response

                if (this.id) {

                    response = await updateTemplate(this.id, payload)

                } else {

                    response = await createTemplate(payload)

                }

                this.$swalToast(response.data.message)

                this.$emit('updated')

                this.$closeModal('template_modal')

                this.reset()

            } catch (error) {

                if (error.type === 'validation') {
                    this.errors = error.errors
                } else {
                    this.$swalToast(error.message, 'error')
                }

            } finally {

                this.setLoading(false)

            }

        },

        reset() {

            this.id = null
            this.name = ''
            this.code = ''
            this.template_id = ''
            this.trigger_after = ''
            this.errors = {}

        }

    }

}
</script>


<template>

    <!-- Modal -->
    <div class="modal fade" id="template_modal">

        <div class="modal-dialog modal-dialog-centered">

            <div class="modal-content">

                <div class="modal-header">

                    <h4 class="modal-title">
                        {{ id ? 'Edit Template' : 'Add Template' }}
                    </h4>

                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>

                </div>

                <form @submit.prevent="save">

                    <div class="modal-body">

                        <!-- Name -->

                        <div class="mb-3">

                            <label class="form-label">Name</label>

                            <input type="text" class="form-control" v-model="name" />

                            <div v-if="errors.name" class="text-danger small">
                                {{ errors.name[0] }}
                            </div>

                        </div>


                        <!-- Code -->

                        <div class="mb-3">

                            <label class="form-label">Code</label>

                            <input type="text" class="form-control" v-model="code" />

                            <div v-if="errors.code" class="text-danger small">
                                {{ errors.code[0] }}
                            </div>

                        </div>


                        <!-- Template ID -->

                        <div class="mb-3">

                            <label class="form-label">Template ID</label>

                            <input type="text" class="form-control" v-model="template_id" />

                            <div v-if="errors.template_id" class="text-danger small">
                                {{ errors.template_id[0] }}
                            </div>

                        </div>


                        <!-- Trigger After -->

                        <div class="mb-3">

                            <label class="form-label">Trigger After (Days)</label>

                            <input type="number" class="form-control" v-model="trigger_after" />

                            <div v-if="errors.trigger_after" class="text-danger small">
                                {{ errors.trigger_after[0] }}
                            </div>

                        </div>

                    </div>


                    <div class="modal-footer">

                        <button type="button" class="btn btn-light" data-bs-dismiss="modal">
                            Cancel
                        </button>

                        <button type="submit" class="btn btn-primary">
                            Save
                        </button>

                    </div>

                </form>

            </div>

        </div>

    </div>

</template>